module.exports = __webpack_public_path__ + "assets/img/word-article-right.12e78b26.png";